import { render, staticRenderFns } from "./UploadsImages.vue?vue&type=template&id=49a75d50&scoped=true&"
import script from "./UploadsImages.vue?vue&type=script&lang=js&"
export * from "./UploadsImages.vue?vue&type=script&lang=js&"
import style0 from "./UploadsImages.vue?vue&type=style&index=0&id=49a75d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a75d50",
  null
  
)

export default component.exports